import axios from 'axios';
import { XDevExtreme } from '@core/utils';
import {
  PagingLoadSortOpt,
  LoadStoreRes,
  GetFnDefaultArgs,
  AxiosPromiseLike,
  AxiosPromiseLikeRes
} from '@core/utils/src/devExtreme/customDataSource/types';
import { Towary, TowaryReadonly } from '../../types';
import { SearchOptions, UpdateTowarKoszyk } from './types';

const endpointSearch = 'XSearch';
const endpointCart = 'KoszykB2B';

export const updateTowarKoszyk = (towarData: UpdateTowarKoszyk) =>
  axios.patch(`${endpointCart}/UpdateKoszyk`, towarData);

export const getCartInfo = () => axios.get(`${endpointCart}/koszykInfo`);

export const fetchTowaryXSearch = (
  fetchOpts: GetFnDefaultArgs<SearchOptions>
): AxiosPromiseLike<LoadStoreRes<Towary>> =>
  axios
    .post<void, AxiosPromiseLikeRes<LoadStoreRes<Towary>>>(
      `${endpointSearch}/GetTowary`,
      fetchOpts
    )
    .then(({ data }) => {
      const calculatedPriceData = data.Dane.map((e) => {
        const Cena = e.Wartosc || 0;

        return { ...e, WartoscZamowienia: Cena * e.IloscTowarowWKoszyku };
      });

      return { data: { ...data, Dane: calculatedPriceData } };
    });

const modifySorting = ([firstItem]: PagingLoadSortOpt[] | undefined[]) => {
  if (!firstItem) return;

  const { desc, selector } = firstItem;

  if (desc && selector === 'Wartosc') {
    return 'CenaMalejaco';
  }

  if (!desc && selector === 'Wartosc') {
    return 'CenaRosnaco';
  }

  if (desc && selector === 'Nazwa') return 'NazwaMalejaco';

  if (!desc && selector === 'Nazwa') return 'NazwaRosnaco';
};

export const towaryXSearchDataSource = (
  getOptions: SearchOptions,
  onDataLoaded?: (towary: TowaryReadonly) => void
) =>
  XDevExtreme.customDataSource<SearchOptions, Towary>({
    key: 'Id',
    get: fetchTowaryXSearch,
    getOptions,
    modifySorting,
    modifyDataOnSuccess: (towary) => {
      if (onDataLoaded) {
        onDataLoaded(towary);
      }

      return towary;
    }
  });
